
export const HeaderData = [
  {
    title: "Home",
    path: "/Home",
  },
  {
    title: "About Us",
    path: "/Home/About_Us",
    heading : "Get Everything About Us",
    details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. About Us",
  },
  {
    title: "Our Project",
    path: "#",
    subNav: [
      {
        subTitle: "Our Projects",
        heading: " Our Projects ",
        details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Our Project",
        path: "/Home/Our_Projects",
      },
      {
        subTitle: "Project Details",
        heading: "Complete Advance Management Study",
        details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Project Details",
        path: "/Home/Our_Projects/Project_Details",
      },
    ],
  },
  {
    title: "Our Service",
    path: "#",
    subNav: [
      {
        subTitle: "Our Services",
        heading: " Pick a Course to Get Started ",
        details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Our Service",
        path: "/Home/Our_Services",
      },
      {
        subTitle: "Our Service List",
        heading: "Complete Advance Management Study",
        details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Our Service List",
        path: "/Home/Our_Service_List",
      },
      {
        subTitle: "Service Details",
        heading: "Complete Advance Management Study",
        details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Service Details",
        path: "/Home/Our_Services/Service_Details",
      },
    ],
  },
  {
    title: "Pages",
    path: "#",
    subNav: [
      {
        subTitle: "Our Team",
        heading: "Meet Our Teams",
        details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Our Team",
        path: "/Home/Our_Team",
      },
      {
        subTitle: "Testimonial",
        heading: "What They Say",
        details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Testimonial",
        path: "/Home/Testimonial",
      },
      {
        subTitle: "FAQs",
        heading: "Questions and Answers",
        details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. FAQs",
        path: "/Home/FAQs",
      },
      {
        subTitle: "Pricing Table",
        heading: "Affordable Price",
        details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Pricing Table",
        path: "/Home/Pricing_Table",
      },
      {
        subTitle: "Comming Soon",
        heading: "Comming Soon",
        details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        path: "/Home/Comming_Soon",
      },
      {
        subTitle: "404",
        heading: "404 Error",
        path: "/Home/404",
        details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. 404",
      },
    ],
  },
  {
    title: "Blogs",
    path: "#",
    subNav: [
      {
        subTitle: "Blogs",
        heading: "Our News and Blogs",
        details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Blogs",
        path: "/Home/Blogs",
      },
      {
        subTitle: "Blog List",
        heading: "Our News and Blogs",
        details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Blog List",
        path: "/Home/Blogs/Blog_List",
      },
      {
        subTitle: "Blog Details",
        heading: "Newly Built Customized Hydro Plants",
        details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Blog Details",
        path: "/Home/Blogs/Blog_Details",
      },
    ],
  },
  {
    title: "Contact Us",
    path: "/Home/Contact_Us",
    heading : "Get In Touch",
    details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Contact Us",
  },
  {
    title: "Get a Qoute",
    heading : "Get An Appointment",
    path: "/Home/Get_Qoute",
    details : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Get a Qoute",
  },
];
